@if (!disabled) {
  <div class="buttons">
    <button nbButton type="button" [shape]="'semi-round'"  [size]="'small'" [status]="'primary'" (click)="this.openPhaser()">
      <nb-icon [icon]="'plus-outline'"></nb-icon>{{ 'addphase' | translate }}
    </button>
    <button nbButton type="button" [shape]="'semi-round'"  [size]="'small'" [status]="'primary'" (click)="this.openAssigner()">
      <nb-icon [icon]="'plus-outline'"></nb-icon>{{ 'addassignment' | translate }}
    </button>
  </div>
}

<section class="project-assignments" [nbSpinner]="loading.getValue()">
  @for (phase of phases; track phase) {
    <article class="phase">
      <div class="panel">
        <div class="phase-header" [class.active]="overlapsToday(phase)">
          <label>{{ phase.name }}</label>
          <bst-menu-dialog class="phase-menu" [menu]="phaseMenu" [data]="phase"></bst-menu-dialog>
        </div>
        <div class="phase-members">
          <table class="assignment-table standard">
            <thead>
              <tr>
                <th>{{ 'projectrole' | translate }}</th>
                <th>{{ 'assignment' | translate }}</th>
                <th>{{ 'projecttimeline' | translate }}</th>
                <th>{{ 'totalhours' | translate }}</th>
                @if (canEdit) {
                  <th>{{ 'offeredhourly' | translate }}</th>
                }
                @if (canEdit) {
                  <th>{{ 'costhourly' | translate }}</th>
                }
                @if (canEdit) {
                  <th>{{ 'margin' | translate }}</th>
                }
                @if (!disabled && canEdit) {
                  <th>{{ 'edit' | translate }}</th>
                }
                @if (!disabled && canEdit) {
                  <th>{{ 'delete' | translate }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @if (!phase.members?.length) {
                <tr>
                  <td [colSpan]="canEdit ? (disabled ? 7 : 9) : 4" class="noresults">
                    {{ 'noassignments' | translate }}
                  </td>
                </tr>
              }
              @for (assignment of phase.members; track assignment) {
                <tr [class.inactive]="assignment.status === ProjectAssignmentStatus.INACTIVE">
                  <td>
                    @if (assignment.project_role) {
                      <span>{{ assignment.project_role?.name }}</span>
                    }
                    @if (!assignment.project_role) {
                      <span>{{ '?' | translate }}</span>
                    }
                  </td>
                  <td>
                    @if (assignment.user) {
                      <nb-user size="medium" [class.clickable]="!disabled && canEdit" (click)="!disabled ? previewUser(assignment.user) : null" [picture]="logo(assignment.user)" [name]="assignment.user.name_first + ' ' + assignment.user.name_last" [title]="assignment.user.username"></nb-user>
                    }
                    @if (!assignment.user) {
                      <span><i>{{ 'removeduser' | translate }}</i></span>
                    }
                  </td>
                  <td>
                    <span>{{ (Globals.fromDateString(assignment.start_on) | date:'mediumDate') + ' - ' + (Globals.fromDateString(assignment.end_on) | date:'mediumDate') }}</span>
                  </td>
                  <td>
                    <span>{{ assignment.dedication }}</span>
                    @if (assignment.status === ProjectAssignmentStatus.INACTIVE) {
                      <span class="small-label" [class.ass-rejected]="assignment.invite_rejected">&nbsp;({{ (assignment.invite_rejected ? 'rejected' : 'inactive') | translate }})&nbsp;</span>
                    }
                    @if (assignment.status === ProjectAssignmentStatus.PENDING) {
                      <span class="small-label ass-pending">&nbsp;({{ 'showpendingusers' | translate }})&nbsp;</span>
                    }
                  </td>
                  @if (canEdit) {
                    <td>
                      <span>{{ assignment.offered | currency:'EUR' }}</span>
                    </td>
                  }
                  @if (canEdit) {
                    <td>
                      <span>{{ assignment.cost | currency:'EUR' }}</span>
                    </td>
                  }
                  @if (canEdit) {
                    <td>
                      <span>{{ assignment.offered ? (margin(null, null, assignment) | percent) : null }}</span>
                    </td>
                  }
                  @if (!disabled && canEdit) {
                    <td>
                      <button nbButton type="button" size="small" status="primary" (click)="editAssignment(assignment)">
                        <nb-icon icon="edit-2-outline"></nb-icon>
                      </button>
                    </td>
                  }
                  @if (!disabled && canEdit) {
                    <td>
                      <button nbButton type="button" size="small" status="danger" (click)="removeAssignment(assignment)">
                        <nb-icon icon="trash-2-outline"></nb-icon>
                      </button>
                    </td>
                  }
                </tr>
              }
              @if (phase.members?.length && canEdit) {
                <tr class="summary-row">
                  <td colspan="3"></td>
                  <td>
                    <div class="price-calculator">
                      <div>
                        <label>{{ 'sumhours' | translate }}</label>
                        <span>{{ totalHours(phase.members) }}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="price-calculator">
                      <div>
                        <label>{{ 'sumpricetoclient' | translate }}</label>
                        <span>{{ totalPriceToClient(null, null, phase.members) | currency:'EUR' }}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="price-calculator">
                      <div>
                        <label>{{ 'sumcosts' | translate }}</label>
                        <span>{{ totalTotalCosts(null, null, phase.members) | currency:'EUR' }}</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="price-calculator">
                      <div>
                        <label>{{ 'summargin' | translate }}</label>
                        <span>{{ totalMargin(null, null, phase.members) | percent }}</span>
                      </div>
                    </div>
                  </td>
                  @if (!disabled) {
                    <td colspan="2"></td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </article>
  }
</section>






<ng-template #userSummaryTemplate let-data="data" let-params="params">
  @if (data && data.length) {
    <div class="price-calculator center final">
      <div>
        <label>{{ 'pricetoclient' | translate }}</label>
        <span>{{ totalPriceToClient(data, params) | currency:'EUR' }}</span>
      </div>
      <div>
        <label>{{ 'totalcosts' | translate }}</label>
        <span>{{ totalTotalCosts(data, params) | currency:'EUR' }}</span>
      </div>
      <div>
        <label>{{ 'margin' | translate }}</label>
        <span>{{ totalMargin(data, params) | percent }}</span>
      </div>
    </div>
  }
</ng-template>

<ng-template #userResultHeaderTemplate>
  <tr class="search-header-row">
    <th>
      {{ 'name' | translate }}
    </th>
    <th>
      {{ 'remaining' | translate }}
    </th>
    <th>
      {{ 'score' | translate }}
    </th>
    <th></th>
  </tr>
</ng-template>
<ng-template #userSelectionHeaderTemplate>
  <tr class="search-header-row">
    <th>
      {{ 'projectpositions' | translate }}
    </th>
    <th></th>
    <th></th>
  </tr>
</ng-template>
<ng-template #userResultBodyTemplate let-data="data" let-params="params" let-select="select" let-i="i">
  <tr class="search-body-row" [class.search-body-header-row]="data.open">
    <td (click)="openDetails(data, params)">
      <nb-user color="#eee" size="medium" [picture]="logo(data.user)" [name]="data.user.name_first + ' ' + data.user.name_last" [title]="data.user.username"></nb-user>
    </td>
    <td [class.full]="data.delta >= 0 && data.delta !== null" [class.block]="data.delta === null" [class.none]="dr(data) < 0 && data.delta !== null">
      <div class="inline-flex">
        <span>{{ data.delta !== null ? ((dr(data) | number:'1.0-0') + ' hrs') : '∞' }}</span>
        @if (data.capacity_updated !== null && data.capacity_updated > 1.0) {
          <nb-icon status="danger" icon="alert-circle" nbTooltipStatus="danger" [nbTooltip]="'overscheduled' | translate:{value: (data.capacity_updated | percent)}"></nb-icon>
        }
      </div>
    </td>
    <td class="rating">
      @if (data.score <= scores[0]) {
        <div class="low" [nbTooltip]="('score' | translate) + ': ' + (data.score * 100).toFixed(0)" nbTooltipStatus="danger">
          <span class="half"></span>
          <span></span>
          <span></span>
        </div>
      }
      @if (data.score > scores[0] && data.score <= scores[1]) {
        <div class="low" [nbTooltip]="('score' | translate) + ': ' + (data.score * 100).toFixed(0)" nbTooltipStatus="danger">
          <span class="whole"></span>
          <span></span>
          <span></span>
        </div>
      }
      @if (data.score > scores[1] && data.score <= scores[2]) {
        <div class="med" [nbTooltip]="('score' | translate) + ': ' + (data.score * 100).toFixed(0)" nbTooltipStatus="warning">
          <span class="whole"></span>
          <span class="half"></span>
          <span></span>
        </div>
      }
      @if (data.score > scores[2] && data.score <= scores[3]) {
        <div class="med" [nbTooltip]="('score' | translate) + ': ' + (data.score * 100).toFixed(0)" nbTooltipStatus="warning">
          <span class="whole"></span>
          <span class="whole"></span>
          <span></span>
        </div>
      }
      @if (data.score > scores[3] && data.score <= scores[4]) {
        <div class="high" [nbTooltip]="('score' | translate) + ': ' + (data.score * 100).toFixed(0)" nbTooltipStatus="success">
          <span class="whole"></span>
          <span class="whole"></span>
          <span class="half"></span>
        </div>
      }
      @if (data.score > scores[4]) {
        <div class="high" [nbTooltip]="('score' | translate) + ': ' + (data.score * 100).toFixed(0)" nbTooltipStatus="success">
          <span class="whole"></span>
          <span class="whole"></span>
          <span class="whole"></span>
        </div>
      }
    </td>
    <td>
      <a (click)="openDetails(data, params)">
        <nb-icon [icon]="data.open ? 'arrow-ios-upward' : 'arrow-ios-downward'" status="basic"></nb-icon>
      </a>
    </td>
  </tr>
  <tr class="search-body-row">
    @if (data.open && data.form) {
      <td colspan="4" [nbSpinner]="this.loading.getValue()">
        @if (data.highlights && data.highlights.length) {
          <div class="highlights">
            @for (h of data.highlights; track $index) {
              <span [innerHTML]="h"></span>
            }
          </div>
        }
        <div class="assignment-options">
          <ul class="field-list">
            <li>
              <label><nb-icon [icon]="'bookmark-outline'"></nb-icon>{{ 'projectphase' | translate }}</label>
              <nb-select [formControl]="data.form.get('Phase_id')" size="small">
                @for (p of phases; track p) {
                  <nb-option [value]="p.id">
                    {{ p.name }}
                  </nb-option>
                }
              </nb-select>
            </li>
            <li>
              <label><nb-icon [icon]="'shield-outline'"></nb-icon>{{ 'projectrole' | translate }}</label>
              @if (projectroles) {
                <nb-select [class.bg-white]="i%2==1" [placeholder]="'selectprojectrole' | translate" [formControl]="data.form.get('ProjectRole_id')" size="small">
                  @for (r of projectroles; track r) {
                    <nb-option [value]="r">
                      {{ r.name }}
                    </nb-option>
                  }
                </nb-select>
              }
            </li>
            <li>
              <label><nb-icon [icon]="'calendar-outline'"></nb-icon>{{ 'time' | translate }}</label>
              <span>{{ (params.time?.start | date:'mediumDate') }} <br> {{ (params.time?.end | date:'mediumDate')}}</span>
            </li>
            <li>
              <label><nb-icon [icon]="'briefcase-outline'"></nb-icon>{{ 'totalhours' | translate }}</label>
              <input nbInput type="number" step="1" min="0" max="99999" [formControl]="data.form.get('capacity')" status="basic" maxlength="5" class="hours" [class.bg-white]="i%2==1" fieldSize="small">
            </li>
            <li>
              <label><nb-icon [icon]="'award-outline'"></nb-icon>{{ 'offeredhourly' | translate }}</label>
              <input nbInput currencyMask [formControl]="data.form.get('offered')" status="basic" class="currency" [options]="Globals.currency" [placeholder]="'entersalary' | translate" [class.bg-white]="i%2==1" fieldSize="small">
            </li>
            <li>
              <label><nb-icon [icon]="'award-outline'"></nb-icon>{{ 'costhourly' | translate }}</label>
              <input nbInput currencyMask [formControl]="data.form.get('cost')" status="basic" class="currency" [options]="Globals.currency" [placeholder]="'entersalary' | translate" [class.bg-white]="i%2==1" fieldSize="small">
            </li>
          </ul>
          <div class="price-calculator center">
            <div>
              <label>{{ 'pricetoclient' | translate }}</label>
              <span>{{ priceToClient(data, params) | currency:'EUR' }}</span>
            </div>
            <div>
              <label>{{ 'totalcosts' | translate }}</label>
              <span>{{ totalCosts(data, params) | currency:'EUR' }}</span>
            </div>
            <div>
              <label>{{ 'margin' | translate }}</label>
              <span>{{ margin(data, params) | percent }}</span>
            </div>
          </div>
        </div>
        <div class="assignment-buttons">
          <button nbButton type="button" status="basic" size="small" (click)="previewUser(data.user)">
            {{ 'viewfullprofile' | translate }}
          </button>
          <button nbButton type="button" [bstErroring]="data.form" (bstErroringSuccess)="setAssignment(data, params, select)" status="primary" size="small">
            <span>{{ 'assigntoproject' | translate }}</span><nb-icon icon="arrow-circle-right-outline"></nb-icon>
          </button>
        </div>
      </td>
    }
  </tr>
</ng-template>
<ng-template #userButtonTemplate let-search="search" let-data="data" let-params="params">
  <div class="buttons">
    <button nbButton status="basic" type="button" (click)="search.cancel()">{{ 'cancel' | translate }}</button>
    <button nbButton status="primary" type="button" [disabled]="!data?.length" [nbTooltip]="'invitetoproject' | translate" nbTooltipStatus="success" (click)="search.finish({invite: true})"><nb-icon icon="email"></nb-icon></button>
    <button nbButton status="primary" type="button" [disabled]="!data?.length" (click)="search.finish()">{{ 'addassignments' | translate }}</button>
  </div>
</ng-template>
<ng-template #userSelectionBodyTemplate let-data="data" let-params="params" let-select="select">
  @if (assignmentForUser(data.user); as ass) {
    <tr class="search-body-row">
      <td (click)="data.open = !data.open">
        <nb-user color="#ccfce3" size="medium" [picture]="logo(data.user)" [name]="data.user.name_first + ' ' + data.user.name_last" [title]="data.user.username"></nb-user>
      </td>
      <td>
        <a (click)="data.open = !data.open">
          <nb-icon [icon]="data.open ? 'arrow-ios-upward' : 'arrow-ios-downward'" status="basic"></nb-icon>
        </a>
      </td>
      <td>
        <a (click)="setAssignment(data, params, select)">
          <nb-icon status="danger" [icon]="'minus-circle-outline'"></nb-icon>
        </a>
      </td>
    </tr>
    <tr class="search-body-row">
      @if (data.open) {
        <td colspan="3">
          <ul class="field-list">
            <li>
              <label><nb-icon [icon]="'bookmark-outline'"></nb-icon>{{ 'projectphase' | translate }}</label>
              <span>{{ phaseForAssignment(ass)?.name }}</span>
            </li>
            <li>
              <label><nb-icon [icon]="'shield-outline'"></nb-icon>{{ 'projectrole' | translate }}</label>
              <span>{{ ass.project_role.name }}</span>
            </li>
            <li>
              <label><nb-icon [icon]="'calendar-outline'"></nb-icon>{{ 'time' | translate }}</label>
              <span>{{ (ass.start_on | date:'mediumDate') }}<br>{{ (ass.end_on | date:'mediumDate')}}</span>
            </li>
            <li>
              <label><nb-icon [icon]="'briefcase-outline'"></nb-icon>{{ 'totalhours' | translate }}</label>
              <span>{{ (ass.dedication || 0) }}</span>
              @if (ass.status === ProjectAssignmentStatus.INACTIVE) {
                <span class="small-label">&nbsp;({{ 'inactive' | translate }})&nbsp;</span>
              }
            </li>
            <li>
              <label><nb-icon [icon]="'award-outline'"></nb-icon>{{ 'offeredhourly' | translate }}</label>
              <span>{{ (ass.offered || 0) | currency:'EUR' }}</span>
            </li>
            <li>
              <label><nb-icon [icon]="'award-outline'"></nb-icon>{{ 'costhourly' | translate }}</label>
              <span>{{ (ass.cost || 0) | currency:'EUR' }}</span>
            </li>
          </ul>
          <div class="price-calculator center">
            <div>
              <label>{{ 'pricetoclient' | translate }}</label>
              <span>{{ priceToClient(data, params, ass) | currency:'EUR' }}</span>
            </div>
            <div>
              <label>{{ 'totalcosts' | translate }}</label>
              <span>{{ totalCosts(data, params, ass) | currency:'EUR' }}</span>
            </div>
            <div>
              <label>{{ 'margin' | translate }}</label>
              <span>{{ margin(data, params, ass) | percent }}</span>
            </div>
          </div>
          <div class="assignment-buttons">
            <button nbButton status="danger" size="small" (click)="setAssignment(data, params, select)">
              <nb-icon [icon]="'minus-circle-outline'"></nb-icon> {{ 'unassignfromproject' | translate }}
            </button>
            <button nbButton status="info" size="small" (click)="editAssignment(ass, false)">
              <nb-icon icon="edit-2-outline"></nb-icon> {{ 'edit' | translate }}
            </button>
          </div>
        </td>
      }
    </tr>
  }
</ng-template>
